export default {
    path: '/detail',
    meta: {
        title: "详情"
    },
    component: () => import('@/views/detail/detail')
}